module.exports = __webpack_public_path__ + "img/wf-finishing-position-10.a19c693c.svg";